import React from 'react';
import { useAppSelector } from 'src/store/hooks';
import { getWorkspaceRouteModule } from 'src/workspace/selectors';
import { isLmsWeb } from 'src/workspace/utils';
import DefaultHeader from '../index.default';
import Navbar from './navbar';

function VymoWebHeader() {
  const workspaceRouteModule = useAppSelector(getWorkspaceRouteModule);
  // TODO:  recheck for stepper login flow
  if (workspaceRouteModule?.hostApp?.hideHeader) {
    return <DefaultHeader />;
  }
  if (isLmsWeb()) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Navbar />;
}

export default VymoWebHeader;
